import { arrayOf, bool, number, shape, string } from 'prop-types';
import servicestype from './services';

// @todo Create reuseable types

const order = shape({
  adults: bool.required,
  agency: shape({
    agencyNumber: string.isRequired,
    creditAgency: bool.required,
    message: string.isRequired,
    showSubId: bool.required,
    subId: string.isRequired,
    userId: string.isRequired,
  }).isRequired,
  arrivalDate: string.isRequired,
  bookingPrice: shape({
    currencyCode: string.isRequired,
    discount: shape({
      amount: number.isRequired,
      currencyCode: string.isRequired,
    }).isRequired,
    lineItems: shape({
      description: string.isRequired,
      maxUnits: number.isRequired,
      minimumPrice: shape({
        amount: number.isRequired,
        currencyCode: string.isRequired,
      }).isRequired,
      name: string.isRequired,
      obligatory: bool.required,
      paymentTime: string.isRequired,
      price: shape({
        amount: number.isRequired,
        currencyCode: string.isRequired,
      }).isRequired,
      serviceGroup: number.isRequired,
      serviceId: string.isRequired,
      subGroup: string.isRequired,
      type: string.isRequired,
      unitCount: number.isRequired,
      unitDescription: string.isRequired,
      unitPrice: shape({
        amount: number.isRequired,
        currencyCode: string.isRequired,
      }).isRequired,
    }).isRequired,
    paymentBeforeArrival: shape({
      amount: number.isRequired,
      currencyCode: string.isRequired,
    }).isRequired,
    prepaidVoucher: shape({
      amount: number.isRequired,
      currencyCode: string.isRequired,
    }).isRequired,
    prepaidVoucherRemainder: shape({
      amount: number.isRequired,
      currencyCode: string.isRequired,
    }).isRequired,
    rates: arrayOf(
      shape({
        localizedPaymentDate: string.isRequired,
        paymentDate: string.isRequired,
        paymentId: number.isRequired,
        price: shape({
          amount: number.isRequired,
          currencyCode: string.isRequired,
        }).isRequired,
      }),
    ),
    rentalPrice: shape({
      amount: number.isRequired,
      currencyCode: string.isRequired,
    }).isRequired,
    totalPrice: shape({
      amount: number.isRequired,
      currencyCode: string.isRequired,
    }).isRequired,
    voucherDiscount: shape({
      amount: number.isRequired,
      currencyCode: string.isRequired,
    }).isRequired,
  }).isRequired,
  children: number.isRequired,
  childrenFreeOfCharge: bool.required,
  cleaningInclude: bool.required,
  company: string.isRequired,
  currencyCode: string.isRequired,
  customer: shape({
    abandonEmail: string.isRequired,
    additionalAddress: string.isRequired,
    additionalPhone: string.isRequired,
    additionalPhoneDialCode: string.isRequired,
    city: string.isRequired,
    customerCountry: string.isRequired,
    email: string.isRequired,
    firstName: string.isRequired,
    floor: string.isRequired,
    lastName: string.isRequired,
    phone: string.isRequired,
    phoneNumber: string.isRequired,
    phoneCode: string.isRequired,
    phoneDialCode: string.isRequired,
    street: string.isRequired,
    streetNumber: string.isRequired,
    title: string.isRequired,
    zipCode: string.isRequired,
  }).isRequired,
  departureDate: string.isRequired,
  information: shape({
    adultCount: number.isRequired,
    allowedPetCount: number.isRequired,
    petsPrice: string.isRequired,
    childrenCount: number.isRequired,
    extraBedCount: number.isRequired,
    kidsFreeOfCharge: number.isRequired,
  }).isRequired,
  ip: string.isRequired,
  language: string.isRequired,
  localizedArrivalDate: string.isRequired,
  localizedDepartureDate: string.isRequired,
  orderTokenId: string.isRequired,
  payment: shape({
    cardHolderName: string.isRequired,
    paymentOptionSelected: string.isRequired,
    paymentOptions: arrayOf(
      shape({
        calculatedFee: shape({
          amount: number.isRequired,
          currencyCode: string.isRequired,
        }).isRequired,
        creditCardExternalId: string.isRequired,
        creditCardName: string.isRequired,
        handleSecondRate: bool.required,
        percentageFee: number.isRequired,
        shopId: string.isRequired,
        voucherEnabled: bool.required,
      }),
    ),
  }).isRequired,
  pets: number.isRequired,
  preCreatedMode: bool.required,
  propertyId: string.isRequired,
  referrer: string.isRequired,
  request: bool.required,
  salesChannel: string.isRequired,
  salesMarket: string.isRequired,
  services: arrayOf(
    servicestype.isRequired,
  ),
  status: string.isRequired,
  theme: string.isRequired,
  type: string.isRequired,
  variableCosts: arrayOf(
    shape({
      description: string.isRequired,
      included: bool.required,
      price: shape({
        amount: number.isRequired,
        currencyCode: string.isRequired,
      }).isRequired,
      unitDescription: string.isRequired,
    }),
  ),
});

export { order as default };
